module.exports = __webpack_public_path__ + "images/xitongguanlitai.svg";